<template>
    <div>
        <b-container fluid class="m-0 px-0 min-vh-100">
            
            <router-view name="header"></router-view>
            
            <b-progress :max="100" class="sticky-top answering-progress" style="z-index: 100" v-if="progress_rate>0">
                <b-progress-bar :max="100" :value="progress_rate" :label="progress_rate > 4 ? `${progress_rate > 100 ? 100 : progress_rate.toFixed(0)}% ` + $t('답변 완료'):''" :key="progress_key"></b-progress-bar>
            </b-progress>

            <b-row no-gutters class="m-0 p-0 align-items-sm-stretch w-100 position-relative" style="overflow-x:hidden;">
                <!-- 왼쪽 사이드 패널 -->
                <b-col id="sidebar" :class="[is_sidebar_collapsed ? 'collapsed':'', 'm-0 p-0 ']">
                    <div :class="home_active_sytle==true?'bgray-200':'bgray-650'" class="h-100">
                        <router-view name="aside" ></router-view>
                    </div>
                </b-col>              

                <b-col class="m-0 p-0">
                    <b-container fluid class="m-0 p-0 h-100">
                    <b-row no-gutters id="main" class="w-100 h-100">
                        <!-- 메인 패널 -->
                        <b-col class="m-0 text-left"> 
                            <router-view :question_code="question_code"></router-view>
                        </b-col>

                        <!-- 오른쪽 사이드 패널 -->
                        <div class="d-none d-sm-block h-100" :class="home_active_sytle==true?'bgray-100':'bgray-100'">
                            <b-col id="right-side" :class="[is_right_side_collapsed==true ? 'collapsed' : '', ' m-0 px-4 position-relative h-100']">
                                <participate-tools></participate-tools>
                            
                                <b-button variant="right-collapse" class="border-0 rounded-0" @click.stop="toggleRightSide">
                                    <span v-if="is_right_side_collapsed==true"> <fa icon="angle-double-left"></fa> </span>
                                    <span v-else> <fa icon="angle-double-right"></fa> </span>
                                </b-button>
                            </b-col>
                        </div>                    
                        <back-to-top></back-to-top>
                    </b-row>
                    </b-container>
                </b-col>
            </b-row>

            <router-view name="footer"></router-view>
            
        </b-container>

        <!-- 도움이 필요하신가요 모달 -->
        <b-button id="need-help" class="rounded-circle position-fixed" variant="dark" size="lg" @click="showNeedHelp" v-b-tooltip.hover :title="$t('도움이 필요하신가요?')"><fa icon="question"></fa></b-button>
        <b-modal ref="need-help" size="lg" :title="$t('도움이 필요하신가요?')"  hide-footer><customer-service @close-need-help="hideNeedHelp"></customer-service></b-modal>

    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import CustomerService from '@shared_components/utils/CustomerService'
import ParticipateTools from '@shared_components/client/components/ParticipateTools'

export default {
    name: "ParticipateMaster",
    components: {
        CustomerService,
        ParticipateTools
    },
    props: {
        question_code: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            is_sidebar_collapsed: false,
            is_right_side_collapsed: false,
            home_active_sytle: true,
            progress_key: 123
        }
    },
    computed: {
        ...mapState(['campaign_in_progress']),
        progress_rate() {
            return this.$store.getters.getProgressRate
        }
    },
    watch: {
        $route:{
            immediate: true,
            handler (to) {
                if(to.path.includes('/questions')){
                    this.home_active_sytle = false
                }
                else if(to.path=='/participate_preface'){
                    this.home_active_sytle = true
                }
            }
        }
    },
    async created () {
        this.$on('toggle-sidebar',this.toggleSidebar)
        if (!this.campaign_in_progress.campaign_id) {
            this.$router.push({ name: 'Main' })
        }
    },
    mounted () {
        window.onbeforeunload = function (e) {
            return '페이지를 새로고침 하실 경우, 평가 선택하기 화면으로 이동하게 됩니다. 이동하시겠습니까?';
        };
    },
    beforeDestroy(){
        window.onbeforeunload = null

        this.update_custom_project_code('')
        this.update_custom_template_loaded(false)
    },
    methods: {
        ...mapMutations('industry_campaigns', ['update_custom_project_code','update_custom_template_loaded']),
        toggleSidebar(){
            this.is_sidebar_collapsed = !this.is_sidebar_collapsed
        },
        toggleRightSide() {
            this.is_right_side_collapsed = !this.is_right_side_collapsed
        },
        showNeedHelp(){
            this.$refs['need-help'].show()
        },
        hideNeedHelp(){
            this.$refs['need-help'].hide()
        },
        toggleSides(mode){
            if (mode == 'close') {
                this.is_sidebar_collapsed = true
                this.is_right_side_collapsed = true
            }
            else {
                this.is_sidebar_collapsed = false
                this.is_right_side_collapsed = false
            }            
        }
    }
}
</script>

<style scoped>
#need-help {
    bottom: 30px;
    right: 30px;
}
.ih-tree{
    text-align: left;
}

.wrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
}

.progress.answering-progress{
    border-radius: 0;
    background-color: var(--gray-100);
}
.progress.answering-progress > .progress-bar {
    background-color: var(--blue);
}

</style>
